/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Pairing_Noun_PodsInputs */



/**
* | output |
* | --- |
* | "pods" |
*
* @param {Tournaments_Lib_Pairing_Noun_PodsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_noun_pods = /** @type {((inputs?: Tournaments_Lib_Pairing_Noun_PodsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Noun_PodsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pods")
	if (locale === "fr") return /** @type {LocalizedString} */ ("pods")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("分组")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("多人桌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("팟")
	return /** @type {LocalizedString} */ ("pods")
});